<template>
  <va-layout>
    <va-app-bar
      slot="app-bar"
      :header-menu="headerMenu"
      :profile-menu="profileMenu"
      dense
      dark
      @toggle="$vuetify.breakpoint.lgAndUp ? (mini = !mini) : (drawer = !drawer)"
    ></va-app-bar>
    <va-sidebar slot="sidebar" v-model="drawer" :menu="sidebarMenu" :mini-variant="mini"></va-sidebar>
    <template slot="header">
      <va-breadcrumbs></va-breadcrumbs>
      <impersonate-message></impersonate-message>
      <SnackBar />
      <SnackBarV2 />
      <SystemNotifications top right :messages.sync="systemNotifications" color="primary" />
    </template>
    <va-aside slot="aside"></va-aside>
    <va-footer slot="footer" :menu="footerMenu">
      &copy; {{ new Date().getFullYear() }}
      <v-icon size="18"> mdi-xml </v-icon>
      with
      <v-icon size="18"> mdi-heart </v-icon>
      by
      <a href="https://www.inlasningstjanst.se">ILT Education</a>
    </va-footer>
  </va-layout>
</template>

<script>
import eventBus from '@/foundations/services/eventBus';
import ImpersonateMessage from '../components/ImpersonateMessage.vue';
import SnackBar from '../components/base/SnackBar.vue';
import SystemNotifications from '../components/base/SystemNotifications.vue';
import nav from '../_nav';
import SnackBarV2 from '../components/base/SnackBarV2.vue';

export default {
  name: 'App',
  components: {
    SnackBarV2,
    ImpersonateMessage,
    SnackBar,
    SystemNotifications,
  },
  data() {
    return {
      drawer: null,
      mini: false,
      headerMenu: [
        {
          link: '/',
          text: this.$t('menu.dashboard'),
        },
      ],
      footerMenu: [],
      profileMenu: [],
      sidebarMenu: nav(this.$i18n, this.$admin),
      systemNotifications: [],
    };
  },
  watch: {
    mini(isDrawerMinified) {
      eventBus.$emit('layout.drawerMinified', isDrawerMinified);
    },
  },
  mounted() {
    eventBus.$on('systemNotifications.push', async (notification) => {
      this.systemNotifications.push(notification);
    });
  },
};
</script>
